/**
 * Ausgewählte Aufgaben als Kontext der ZEO-Eingabe (27.10.2026): erkennt NUR, ob der Nutzer die Auswahl zusammenführen oder erledigen möchte –
 * beides öffnet ausschließlich die Aufgaben-2.0-Vorschau (keine Ausführung). Fragen („Welche kann ich erledigen?“) bleiben Fragen an ZEO.
 * 'chat' (Prod-Fund 27.10.2026): Dokumentieren/Nachfrage „Hast du hinterlegt …?“, berichtete Einreichung und „ja“/„nein“ gehen an den normalen
 * ZEO-Chat – nur dort gibt es den bestätigungspflichtigen Schreibweg (Vorschlag → „ja“ → Speichern → Rücklesen); die Auswahl-Frage ist reine Analyse.
 */
const ZUSAMMEN = /\bzusammen\s*(?:f(?:ü|ue)hr|fass|leg)\w*|\b(?:f(?:ü|ue)hr|f(?:ü|ue)g|fass|leg)\w*\b[^.?!\n]{0,80}\bzusammen\b|\bzu\s+einer(?:\s+einzigen)?\s+aufgabe\b/i;
const ERLEDIGEN = /\bals\s+erledigt\b|\berledigt\s+markier|\berledige\b|\berledigen\s*(?:sie|du)?\s*[.!]?\s*$|\bschlie(?:ß|ss)\w*\b[^.?!\n]{0,60}\bab\b|\babschlie(?:ß|ss)en\s*[.!]?\s*$/i;

const DOKU = /\b(?:dokumentier\w*|vermerk\w*|notier\w*|hinterleg\w*|festhalt\w*|halt\w*\s+(?:\w+\s+){0,3}fest|trag\w*\s+(?:\w+\s+){0,4}ein|eingetragen|erfasst)\b/i;
const BERICHT = /\b(?:ich|wir)\s+(?:habe|haben|hab)\b[^?]{0,200}\b(?:eingereicht|versandt|versendet|verschickt|geschickt|abgeschickt|(?:ü|ue)bermittelt|gefaxt)\b/i;
const KURZ_ANTWORT = /^(?:ja|nein|ok|okay|abbrechen)\b[\s,.!]*(?:bitte|genau|so)?[\s.!]*$/i;

export function aufgabenKontextAbsicht(text) {
  const t = String(text || '').trim();
  if (KURZ_ANTWORT.test(t) || DOKU.test(t) || (BERICHT.test(t) && !/\?\s*$/.test(t))) return 'chat';
  const frage = /\?\s*$/.test(t) || /^(?:welche|was|wie|wo|warum|wann|gibt|sind|ist|kann|k(?:ö|oe)nnte|sollte)\b/i.test(t);
  if (ZUSAMMEN.test(t) && !frage) return 'zusammenfuehren';
  if (ERLEDIGEN.test(t) && !frage) return 'erledigen';
  return 'frage';
}
